import { createFileRoute, redirect } from '@tanstack/react-router'

import { publicEntryPath } from '@/features/auth/route-access'
import { isAuthenticated } from '@/features/auth/store'
import { isWebViewSession } from '@/lib/webview-session'

export const Route = createFileRoute('/app-session-required')({
  beforeLoad: () => {
    if (!isWebViewSession() || isAuthenticated()) {
      throw redirect({ to: publicEntryPath(), replace: true })
    }
  },
  component: AppSessionRequired,
})

function AppSessionRequired() {
  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <section aria-labelledby="app-session-title" className="max-w-sm text-center">
        <h1 id="app-session-title" className="text-ink text-xl font-bold">
          Sesi aplikasi belum tersedia
        </h1>
        <p className="text-ink mt-3 text-sm leading-relaxed">
          Tutup halaman ini, lalu buka kembali dari aplikasi Lion Parcel. Jika sesi kamu sudah
          berakhir, masuk kembali melalui aplikasi.
        </p>
      </section>
    </main>
  )
}
